import type { SVGProps } from 'react'
const SvgSyFileDock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M5 5a2 2 0 0 1 2-2h4.75a.25.25 0 0 1 .25.25V8a2 2 0 0 0 2 2h4.75a.25.25 0 0 1 .25.25V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
		/>
		<path d="M13 8V3.604a.25.25 0 0 1 .427-.177l5.146 5.146a.25.25 0 0 1-.177.427H14a1 1 0 0 1-1-1m-4.5 5a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyFileDock
